/** Video.js / HTML5 MediaError-shaped values. */
export type VideoPlaybackMediaError = {
  code?: number | null;
  message?: string | null;
} | null;

/**
 * User-facing copy for a Video.js / HTMLMediaElement error.
 * Codes match the W3C MediaError constants (1–4). Wording follows Video.js /
 * WHATWG meaning (code 4 is an unsuitable source, not specifically a codec).
 */
export function getVideoPlaybackErrorMessage(
  err: VideoPlaybackMediaError
): string {
  const code = err?.code;

  if (code === 1) {
    return 'Video playback was aborted.';
  }
  if (code === 2) {
    return 'A network error interrupted the video download.';
  }
  if (code === 3) {
    return 'Could not decode this video. It may be corrupt or use features your browser does not support.';
  }
  if (code === 4) {
    return 'Could not load this video. The source may be missing, invalid, or unsupported.';
  }
  return 'Could not display this video.';
}
